<template>
  <div>
    <div class="mb-3 text-center">
      <ins
        class="adsbygoogle"
        style="display:block"
        data-ad-client="ca-pub-8326584585992829"
        data-ad-slot="3714619695"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>

    <div class="mb-4">
      <router-link
        v-if="genre"
        :to="`/releases?genre=${genre}`"
        class="btn btn-warning"
      >
        <b>Genre:</b> {{ genre }} <span class="fa fa-times ml-1" />
      </router-link>
      <router-link
        v-if="style"
        :to="`/releases`"
        class="btn btn-warning ml-2"
      >
        <b>Style:</b> {{ style }} <span class="fa fa-times ml-1" />
      </router-link>
    </div>

    <div class="iq-card">
      <div class="iq-card-header d-flex justify-content-between align-items-center">
        <div class="iq-header-title">
          <h1 class="card-title h4">
            {{ $t('showing') }} {{ totalReleases }} <span class="text-primary">{{ genre }}</span> <span v-if="style && style !== 'All Styles'">/</span> <span
              v-if="style !== 'All Styles'"
              class="text-primary"
            >{{ style }}</span> {{ $t('releases') }}
          </h1>
        </div>
        <div
          id="feature-album-slick-arrow"
          class="slick-aerrow-block"
        >
          <router-link
            :to="`/releases?genre=${genre.replace('/', '-')}&style=${style.replace('/', '-')}&page=${currentPage - 1}`"
            class="btn btn-primary"
            :disabled="currentPage <= 1"
          >
            <i class="fa fa-chevron-left" />
          </router-link>
          <a
            href="javascript:void(0)"
            class="btn btn-default"
          >Page {{ currentPage }} of {{ getTotalPages() }}</a>
          <router-link
            :to="`/releases?genre=${genre.replace('/', '-')}&style=${style.replace('/', '-')}&page=${currentPage + 1}`"
            class="btn btn-primary"
            :disabled="currentPage >= getTotalPages()"
          >
            <i class="fa fa-chevron-right" />
          </router-link>
        </div>
      </div>
      <div class="iq-card-body">
        <p
          v-if="loading"
          class="text-center p-3"
        >
          <i class="fa fa-spinner fa-spin" />
        </p>
        <ul
          v-if="!loading"
          class="list-unstyled row iq-box-hover mb-0"
        >
          <li
            v-for="(release, index) in releases"
            :key="`artists_${index}`"
            class="col-xl-3 col-lg-3 col-md-4 iq-music-box"
          >
            <div class="iq-card">
              <div class="iq-card-body p-0">
                <div class="iq-thumb">
                  <div class="iq-music-overlay" />
                  <router-link :to="`/releases/${release.key}`">
                    <img
                      onerror="this.src = '/assets/img/img-placeholder.jpg'"
                      :src="release.cover_image_small || release.cover_image || defaultImage"
                      class="img-border-radius img-fluid w-100"
                      alt=""
                    >
                  </router-link>
                  <div class="overlay-music-icon">
                    <router-link :to="`/releases/${release.key}`">
                      <i class="las la-eye" />
                    </router-link>
                  </div>
                </div>
                <div class="feature-list text-center">
                  <h6 class="font-weight-600 mb-0">
                    <router-link :to="`/releases/${release.key}`">
                      {{ release.title }}
                    </router-link>
                  </h6>
                  <p class="mb-0">
                    <img
                      class="country-flag mr-2"
                      :src="`/assets/img/countries/${release.user.country || 'default'}.png`"
                      onerror="this.src = '/assets/img/countries/default.png'"
                      :alt="getCountryName(release.user.country)"
                      :title="getCountryName(release.user.country)"
                      width="16"
                    >
                    <router-link :to="`/artist/${release.artist.key}`">
                      {{ release.artist.name }}
                    </router-link>
                  </p>
                  <p v-if="!genre">
                    <router-link :to="`/releases?genre=${release.main_genre}`">
                      {{ release.main_genre }}
                    </router-link>
                  </p>
                  <p v-if="genre">
                    <router-link :to="`/releases?genre=${genre}&style=${release.style}`">
                      {{ release.style }}
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import genres from '../data/genres';
import _ from 'underscore';
import Music from '../services/music';
import countries from '../data/countries';
import events from '../utils/events';
import adSenseAutoAds from '../utils/ads';

export default {
  name: 'ReleasesPage',
  data: function () {
    return {
      loading: false,
      genre: '',
      defaultImage: '/assets/img/img-placeholder.jpg',
      genres: _.map(genres, (item, index) => index),
      styles: [],
      releases: [],
      totalReleases: 0,
      searchLimit: 50,
      currentPage: 1,
      results: 0,
      search: '',
    }
  },
  watch: {
    '$route': function () {
      this.initParams();
    }
  },
  mounted: function () {
    let description = 'Explore our extensive catalog featuring a wide range of genres, including indie rock, electronic, hip-hop, jazz, folk, alternative, pop, and more. Discover your favorite music genres and find new sounds to inspire your musical journey. Start exploring now!';
    let title = 'Indiefy: Explore Genre Diversity: Indie, Electronic, Hip-Hop & More!';

    if (this.$route.query.genre) {
      title = `Indiefy: Explore our ${this.$route.query.genre.replace('-', '/')} Diversity and More Independent Music!`;
      description = `Explore our extensive ${this.$route.query.genre.replace('-', '/')} catalog featuring a wide range of subgenres. Discover your favorite music genres and find new sounds to inspire your musical journey. Start exploring now!`;

      if (this.$route.query.style) {
        title = `Indiefy: Explore our ${this.$route.query.genre.replace('-', '/')} - ${this.$route.query.style} Diversity and More Independent Music!`;
        description = `Explore our extensive ${this.$route.query.genre.replace('-', '/')} - ${this.$route.query.style.replace('-', '/')} catalog featuring a wide range of subgenres. Discover your favorite music genres and find new sounds to inspire your musical journey. Start exploring now!`;
      }
    }

    window.document.title = title;
    document.querySelector('meta[property="og:title"]')['content'] = title;
    document.getElementsByTagName('meta')['description'].content = description;
    document.querySelector('meta[property="og:description"]')['content'] = description;
    document.querySelector('meta[property="og:url"]')['content'] = location.href;

    events.$emit('removePlayer');

    if (!this.$route.query.genre && !this.$route.query.style) {
      setTimeout(() => {
        this.prerenderReady = true;
      }, 1000);
    }

    setTimeout(() => {
      // Use the ads utility to push regular ad units
      adSenseAutoAds.pushAd({});
    }, 100);
  },
  created: function () {
    this.initParams();
  },
  methods: {
    getCountryName: function (userCountry) {
      let country = _.find(countries, item => item.code === userCountry)

      if (country) {
        return country.name;
      } else {
        return userCountry || 'N/A';
      }
    },
    getTotalPages: function () {
      return Math.ceil(this.totalReleases / this.searchLimit) || '1';
    },
    getReleases: function () {
      let style = this.style.replace('-', '/');
      let filters = {
        limit: this.searchLimit,
        page: this.currentPage - 1,
        orderBy: 'release_date'
      };

      if (this.genre) {
        filters.main_genre = this.genre.replace('-', '/');
      }

      if (style) {
        filters.style = style;
      }

      this.loading = true;

      if (this.currentPage === 1) {
        this.results = 0;
        this.totalReleases = 0;
      }

      this.releases = [];

      Music.getReleases(filters).then(response => {
        this.releases = response.data.items;
        this.results = response.data.results;
        this.totalReleases = response.data.total;
        this.loading = false;

        setTimeout(() => {
          this.prerenderReady = true;
        }, 1000);
      });
    },
    initParams: function () {
      this.genre = this.$route.query.genre || '';
      this.style = this.$route.query.style || '';
      this.currentPage = parseInt(this.$route.query.page || 1);
      this.getReleases()
    }
  }
};
</script>

<style scoped></style>
